module.exports = __webpack_public_path__ + "0e76acd0a8be962e87da787aabca8491.svg";